// eslint-disable-next-line
export default (phoneNumber: string | number = ''): string =>
  `${phoneNumber}`.replace(/[^\d+]/g, '');
